<template>
  <div class="cascader-box">
    <p class="filter-tit">
      {{ fieldname }}
    </p>
    <cube-checkbox-group
      v-if="data.fieldkey === 'follow_userid' && options"
      v-model="checked"
      class="follow-checkbox-group"
      :options="options"
      shape="square"
      @input="checkboxHandle"
    />
    <cube-checkbox
      v-if="data.fieldkey === 'input_userid'"
      v-model="is_universal_form"
      shape="square"
      @input="checkboxInput"
    >
      {{ $t('message["1728"]') }}
    </cube-checkbox>
    <div class="cascader-con">
      <div
        v-for="(val, index) in values"
        :key="val._id"
      >
        <members-cascader
          v-if="lists"
          :ref="`members${index}`"
          :field-key="data.fieldkey"
          :field-type="data.fieldtype"
          :val="val"
          :default-value="getDefault(val)"
          :can-delete="values.length > 1"
          :source="lists"
          @change="changeHandle(index, $event)"
          @remove="deleteHandle(index)"
        />
      </div>
      <a
        href="javascript:;"
        class="add-item-btn"
        @click="addHandle"
      ><i>+</i> {{ $t('message["1561"]') }}</a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import MembersCascader from './MembersCascader'
import { getJoinTeamInfo, getAuthTeamInfo, getMyAuthTeamInfo } from '@/services/index'

export default {
  components: {
    MembersCascader
  },
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default () {
        return {}
      }
    },
    value: {
      type: [Array, Object],
      default () {
        let { fieldkey } = this.data
        if (fieldkey === 'follow_userid' || fieldkey === 'input_userid') {
          return {}
        } else {
          return []
        }
      }
    }
  },
  data () {
    let values = this.initValues()
    let options = this.initOptions()

    return {
      checked: this.value.follow_status || [],
      is_universal_form: !!this.value.is_universal_form,
      options,
      values,
      lists: null,
      inputValValid: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    },
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type
    },
    fieldname () {
      return this.data.fieldname
    },
    fieldkey () {
      return this.data.fieldkey
    },
    fieldtype () {
      return this.data.fieldtype
    }
  },
  async created () {
    let { fieldkey = '', fieldtype, data = {} } = this
    if (fieldkey === 'from_info' || fieldtype === 'select_reception') {
      if (data.child || data.options) {
        let child = data.child || data.options
        if (Array.isArray(child) && child.length) {
          this.lists = child
        }
      }
    } else {
      await this.getData()
    }
  },
  methods: {
    validate (cb) {
      for (let index in this.values) {
        this.$refs[`members${index}`] && this.$refs[`members${index}`] && this.$refs[`members${index}`][0].validate(cb)
      }
    },

    initOptions () {
      let { fieldkey, options = [] } = this.data
      if (fieldkey === 'follow_userid') {
        options = options.filter(item => (item.id === 3 && this.enableshare) || item.id !== 3)
        options = options.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      }

      return options
    },

    initValues () {
      let { fieldkey, fieldtype } = this.data
      let arr
      let values = []
      let value
      if (fieldkey === 'follow_userid') {
        value = this.value || {}
        const {
          follow_status: checkes = [],
          follow_userid: lists = []
        } = value
        value.follow_status = checkes
        value.follow_userid = lists
        arr = lists
      } else if (fieldkey === 'input_userid') {
        value = this.value || {}
        const {
          input_userid: inputUserid = [],
          is_universal_form: isUniversalForm
        } = value
        value.input_userid = inputUserid
        value.is_universal_form = isUniversalForm ? 1 : 0
        arr = inputUserid
      } else {
        arr = value = this.value || []
      }

      if (this.data.fieldkey !== 'from_info' && fieldtype !== 'select_reception') {
        values = arr.length
          ? arr.map((item = {}) => {
            item._id = Math.random()
            return item
          })
          : [{ _id: Math.random() }]
      } else {
        values = arr.length
          ? arr.map((item = []) => {
            return item
          })
          : [[]]
      }
      return values
    },

    getDefault (val) {
      if (!val) return
      let { fieldkey = '', fieldtype } = this
      if (fieldkey === 'from_info' || fieldtype === 'select_reception') {
        if (!val.length) return
        val.forEach(item => {
          item.name = item.name || item.fieldname
          return item
        })
        return val
      } else {
        const { _id, ...other } = val
        return other
      }
    },

    async getData () {
      let { fieldkey = '', fieldtype } = this
      let params = {}
      let chain
      let key = fieldkey && fieldkey.split('_') && fieldkey.split('_')[0]

      if (key === 'follow-input' || key === 'follow') { key = 'followup' }
      if (key === 'input') { key = 'add' }

      if (this.from === 'all' && this.type.indexOf(key) !== -1) {
        params = { pk: `inquiry-${key}` }

        chain = await getMyAuthTeamInfo()
      } else if (fieldtype === 'selectrolegroup') { // 所属团队小组
        // params = { pk: 'inquiry-audit' }
        params = { pk: `inquiry-${key}` }
        if (this.type === 'inquiry-manager-share' || this.type === 'inquiry-manager-need-assign') {
          params.type = 1
          chain = await getAuthTeamInfo()
        } else {
          chain = await getJoinTeamInfo()
        }
      } else {
        params = { pk: `inquiry-${key}` }

        chain = await getAuthTeamInfo()
      }
      await chain
        .params(params)
        .onSuccess(payload => {
          this.lists = payload
        })
        .fetch()
    },
    focusHandle () {
      this.visible = true
    },
    changeHandle (index, value) {
      const { fieldkey, fieldtype } = this.data
      if (!Array.isArray(value)) return
      if (value.length) {
        const [firstItem] = value
        if (firstItem.keyname === 'all' && firstItem.id === '-1') {
          return
        }
      }
      const obj = {}
      if (fieldkey !== 'from_info' && fieldtype !== 'select_reception') {
        value.forEach(item => {
          const { id, keyname } = item
          obj[keyname] = id
          delete obj._id
        })
      }

      if (fieldkey === 'from_info') {
        this.values.splice(index, 1, value)
        this.$emit('change', this.values)

        // 禁止选第二级
        if (value.length === 2) {
          if (value[1] && value[1].fieldtype === 'text') {
            value[value.length - 1].showUrlInput = true
            value[value.length - 1].inputVal = ''
            value[value.length - 1].inputPlaceholder = this.$t('message["751"]') + '' + value[1].name
          } else {
            value = []
          }
        }
        // 选了第三级，清空输入框
        if (value.length === 3) {
          value[value.length - 1].showUrlInput = false
          value[value.length - 1].inputVal = ''
          value[value.length - 1].inputPlaceholder = this.$t('message["751"]')
        }
      } else if (fieldtype === 'select_reception') {
        this.values.splice(index, 1, value)
        this.$emit('change', this.values)
      } else if (fieldkey === 'follow_userid' || fieldkey === 'input_userid') {
        this.value[fieldkey][index] = obj
        this.$emit('change', this.value)
      } else {
        this.values.splice(index, 1, obj)
        this.$emit('change', this.values)
      }
    },
    checkboxHandle (checked) {
      this.value.follow_status = checked
      this.$emit('change', this.value)
    },
    checkboxInput (checked) {
      this.is_universal_form = checked
      this.value.is_universal_form = checked ? 1 : 0
      this.$emit('change', this.value)
    },
    addHandle () {
      let { fieldkey = '', fieldtype } = this
      if (fieldkey === 'from_info' || fieldtype === 'select_reception') {
        this.values.push([])
      } else {
        this.values.push({ _id: Math.random() })
      }
    },
    deleteHandle (index) {
      let { fieldkey = '' } = this
      this.$delete(this.values, index)
      if (fieldkey === 'follow_userid' || fieldkey === 'input_userid') {
        this.value[fieldkey] = this.values
        this.$emit('change', this.value)
      } else {
        this.$emit('change', this.values)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cascader-box {
  .cascader-con {
    padding: 16px 0;
  }
  .add-item-btn {
    display: block;
    width: 106px;
    height: 32px;
    line-height: 32px;
    margin: 12px 0 0 16px;
    font-size: 16px;
    color: #333;
    text-align: center;
    background: rgba(245, 245, 245, 1);
    border-radius: 2px;
    border: 1px solid rgba(235, 235, 235, 1);
    i {
      font-style: normal;
      color: #999;
    }
  }
}
</style>
<style lang="scss">
.follow-checkbox-group {
  &::before {
    border-top: none;
  }
  &::after {
    border-bottom: none;
  }
  .cube-checkbox {
    display: inline-block;
  }
  background: none;
  .cube-checkbox-wrap {
    padding-bottom: 0;
    &:after {
      border-bottom: none;
    }
  }
}
</style>
